import { Col, Flex, Form, InputNumber, Row } from "antd"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
import { TRIP_PRICE } from "../../utils/constants"
import { InfoTooltip } from "ui/Tooltip/InfoTooltip"
import { CustomInput } from "ui/Input"
import { AllowedTypesBlock } from "./AllowedTypesBlock"
import { spacings } from "themes/variables"
import { useEffect, useState } from "react"
import { ExtraGuestsBlock } from "./ExtraGuestsBlock"
import { useSelector } from "react-redux"
import { modelSelector } from "store/selectors"

export const FlatRateFormItems = ({ form, record }) => {
  const [t] = useTranslation()
  const [childrenAllowed, setChildrenAllowed] = useState(record?.children_allowed)
  const [infantsAllowed, setInfantsAllowed] = useState(record?.infants_allowed)
  const [passengersAllowed, setPassengersAllowed] = useState(record?.passengers_allowed)
  const { min_guests, max_guests } = useSelector(modelSelector("trip"))

  useEffect(() => {
    form.setFieldsValue({
      [TRIP_PRICE.FLAT_RATE]: record?.[TRIP_PRICE.FLAT_RATE],
      [TRIP_PRICE.CHILDREN_ALLOWED]: record?.[TRIP_PRICE.CHILDREN_ALLOWED],
      [TRIP_PRICE.INFANTS_ALLOWED]: record?.[TRIP_PRICE.INFANTS_ALLOWED],
      [TRIP_PRICE.PASSENGERS_ALLOWED]: record?.[TRIP_PRICE.PASSENGERS_ALLOWED],
      [TRIP_PRICE.MAX_EXTRA_GUESTS]: record?.[TRIP_PRICE.MAX_EXTRA_GUESTS],
      [TRIP_PRICE.PRICE_ADULT]: record?.[TRIP_PRICE.PRICE_ADULT],
      [TRIP_PRICE.PRICE_CHILD]: record?.[TRIP_PRICE.PRICE_CHILD],
      [TRIP_PRICE.PRICE_INFANT]: record?.[TRIP_PRICE.PRICE_INFANT],
      [TRIP_PRICE.PRICE_PASSENGER]: record?.[TRIP_PRICE.PRICE_PASSENGER],
    })
  }, [record, form])

  return (
    <Flex vertical gap={spacings.XL}>
      <Row gutter={16}>
        <Col span={12} md={12} sm={24}>
          <Form.Item
            name={TRIP_PRICE.FLAT_RATE}
            label={t("experiences.scheduling.sections.length_and_rates.set_flat_rate")}
            rules={[{ required: true, message: t("form_validation.cannot_be_blank") }]}
            className="mb-0"
          >
            <InputNumber prefix="$" size="large" placeholder="100" min={0} className="w-100" />
          </Form.Item>
        </Col>
        <Col span={12} md={12} sm={24}>
          <Form.Item
            label={
              <Flex align="center" gap="small">
                {t("experiences.scheduling.sections.length_and_rates.max_guests")}
                <InfoTooltip title={t("experiences.scheduling.sections.length_and_rates.max_guests_info")} />
              </Flex>
            }
            className="mb-0"
          >
            <CustomInput size="large" className="w-100" value={`${min_guests || 1}-${max_guests || "∞"}`} disabled />
          </Form.Item>
        </Col>
      </Row>
      <AllowedTypesBlock
        setChildrenAllowed={setChildrenAllowed}
        setInfantsAllowed={setInfantsAllowed}
        setPassengersAllowed={setPassengersAllowed}
      />
      <ExtraGuestsBlock
        form={form}
        childrenAllowed={childrenAllowed}
        infantsAllowed={infantsAllowed}
        passengersAllowed={passengersAllowed}
      />
    </Flex>
  )
}

FlatRateFormItems.propTypes = {
  form: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
    setFieldsValue: PropTypes.func.isRequired,
  }).isRequired,
  record: PropTypes.shape({
    children_allowed: PropTypes.bool,
    infants_allowed: PropTypes.bool,
    passengers_allowed: PropTypes.bool,
  }),
}